import { ROUTE_PATH } from 'common/constants/sm-constants';
import {
  FormMetaModel,
  SmBtnMetaModel,
  SmCheckboxModel,
  SmDatepickerModel,
  SmMetaInputModel,
} from 'common/models/utility-models/meta-model';

export class StudentInternshipDetailsMetaModel extends FormMetaModel {
  constructor() {
    super(
      '',
      ROUTE_PATH.studentInternship,
      ROUTE_PATH.studentInternshipDetails,
      1
    );
  }
  override initProperties(): any {
    const formInfo = super.initProperties();
    const yescheck = new SmCheckboxModel(
      'yescheck',
      'yescheck',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'Yes',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const nocheck = new SmCheckboxModel(
      'nocheck',
      'nocheck',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'No',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const studentExamStartDate = new SmDatepickerModel(
      'studentExamStartDate',
      'studentExamStartDate',
      'datepicker',
      true,
      'col-12 col-md-4',
      1,
      2,
      'Start Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD MMM YYYY',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: 'Start Date',
        isIconVisible: true,
      }
    );

    const studentExamEndDate = new SmDatepickerModel(
      'studentExamEndDate',
      'studentExamEndDate',
      'datepicker',
      true,
      'col-12 col-md-4',
      1,
      2,
      'End Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD MMM YYYY',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: 'End Date',
        isIconVisible: true,
        isLabel: false,
      }
    );

    const studentSummerVacationStartDate = new SmDatepickerModel(
      'studentSummerVacationStartDate',
      'studentSummerVacationStartDate',
      'datepicker',
      true,
      'col-12 col-md-4',
      1,
      2,
      'Start Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD MMM YYYY',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: 'Start Date',
        isIconVisible: true,
        isLabel: false,
      }
    );

    const studentSummerVacationEndDate = new SmDatepickerModel(
      'studentSummerVacationEndDate',
      'studentSummerVacationEndDate',
      'datepicker',
      true,
      'col-12 col-md-4',
      1,
      2,
      'End Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD MMM YYYY',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: 'End Date',
        isIconVisible: true,
        isLabel: false,
      }
    );

    const studentExpectedInternshipStartDate = new SmDatepickerModel(
      'studentExpectedInternshipStartDate',
      'studentExpectedInternshipStartDate',
      'datepicker',
      false,
      'col-12 col-md-4',
      1,
      2,
      'Start Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD MMM YYYY',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: 'Start Date',
        isIconVisible: true,
        isLabel: false,
      }
    );

    const studentExpectedInternshipEndDate = new SmDatepickerModel(
      'studentExpectedInternshipEndDate',
      'studentExpectedInternshipEndDate',
      'datepicker',
      false,
      'col-12 col-md-4',
      1,
      2,
      'End Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD MMM YYYY',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false,
      null,
      false,
      {
        isPlaceholder: true,
        placeholderLabel: 'End Date',
        isIconVisible: true,
        isLabel: false,
      }
    );

    const studentAvailabilityRemark = new SmMetaInputModel(
      'studentAvailabilityRemark',
      'studentAvailabilityRemark',
      'input',
      false,
      'form-control col-12 col-md-6',
      1,
      1,
      'Remarks',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      '',
      null,
      false,
      null,
      false,
      '',
      null,
      false,
      false,
      false,
      '',
      false
    );

    const externalCompanyName = new SmMetaInputModel(
      'externalCompanyName',
      'externalCompanyName',
      'input',
      false,
      'form-control col-12 col-md-6',
      1,
      1,
      '', //'Company Name'
      
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      '',
      null,
      false,
      null,
      false,
      '',
      null,
      false,
      false,
      false,
      '',
      false
    );

    const externalCompanyLocation = new SmMetaInputModel(
      'externalCompanyLocation',
      'externalCompanyLocation',
      'input',
      false,
      'form-control col-12 col-md-6',
      1,
      1,
      '', //Location was here  'Company Location'
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      false,
      true,
      false,
      false,
      false,
      false,
      false,
      '',
      null,
      false,
      null,
      false,
      '',
      null,
      false,
      false,
      false,
      '',
      false
    );

    const reasonForNotJoined = new SmMetaInputModel(
      'reasonForNotJoined',
      'reasonForNotJoined',
      'input',
      false,
      'form-control col-12 col-md-6',
      1,
      1,
      'Reason',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      null,
      false,
      null,
      false,
      '',
      null,
      false,
      false,
      false,
      '',
      false
    );

    const reasonForNotContinued = new SmMetaInputModel(
      'reasonForNotContinued',
      'reasonForNotContinued',
      'input',
      false,
      'form-control col-12 col-md-6',
      1,
      1,
      'Mention Reason',
      'text',
      '',
      false,
      true,
      true,
      false,
      200,   //this is made 200 from 100
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      null,
      false,
      null,
      false,
      '',
      null,
      false,
      false,
      false,
      '',
      false
    );

    const anotherInternshipYes = new SmCheckboxModel(
      'anotherInternshipYes',
      'anotherInternshipYes',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'Yes',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const anotherInternshipNo = new SmCheckboxModel(
      'anotherInternshipNo',
      'anotherInternshipNo',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'No',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const studentjoinedinternshipyes = new SmCheckboxModel(
      'studentjoinedinternshipyes',
      'studentjoinedinternshipyes',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'Yes',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const studentjoinedinternshipno = new SmCheckboxModel(
      'studentjoinedinternshipno',
      'studentjoinedinternshipno',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'No',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const isInternshipcompleted = new SmCheckboxModel(
      'isInternshipcompleted',
      'isInternshipcompleted',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'Yes',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const isInternshipnotcompleted = new SmCheckboxModel(
      'isInternshipnotcompleted',
      'isInternshipnotcompleted',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'No',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );
    const isInternshipCompletedFieldSubmitted = false;
    const isStudentJoinedAndContinued = false;
    const isStudentJoined = 0;
    const tabNumber: string = '';
    const internshipcompleteDetails: studentInternshipDataModel[] = [];
    const isvisible: boolean = true;
    const isInternshipJoined: boolean = true;
    const uploadFile: boolean = false;
    const file: string = '';
    // const fileName: string = 'No file selected';
    const alertMsg: boolean = false;
    const alertDesc: string = "File must be in PDF, JPEG, PNG, JPG format (2mb).";
    const   joined: boolean = false;
    const continued:boolean=false;
    const buttons = {
      submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
      isFormControl: false,
    };

    const feeback = {
      submit: new SmBtnMetaModel('Submit', '', true, false, true, true),
      isFormControl: false,
    };

    const internshipEndDatePassed : boolean = false;

    const isEditable = [
      studentExamStartDate,
      studentExamEndDate,
      studentSummerVacationStartDate,
      studentSummerVacationEndDate,
      studentExpectedInternshipStartDate,
      studentExpectedInternshipEndDate,
      studentAvailabilityRemark,
      externalCompanyName,
      externalCompanyLocation,
    ];

    return {
      formInfo,
      studentExamStartDate,
      isEditable,
      yescheck,
      nocheck,
      studentExamEndDate,
      studentSummerVacationStartDate,
      studentSummerVacationEndDate,
      studentExpectedInternshipStartDate,
      studentExpectedInternshipEndDate,
      studentAvailabilityRemark,
      buttons,
      internshipcompleteDetails,
      externalCompanyName,
      externalCompanyLocation,
      anotherInternshipYes,
      anotherInternshipNo,
      studentjoinedinternshipyes,
      studentjoinedinternshipno,
      feeback,
      reasonForNotJoined,
      isInternshipcompleted,
      isInternshipnotcompleted,
      tabNumber,
      reasonForNotContinued,
      isvisible,
      isInternshipJoined,
      isInternshipCompletedFieldSubmitted,
      uploadFile,
      file,
      // fileName,
      alertMsg,
      alertDesc,
      joined,
      internshipEndDatePassed,
      isStudentJoinedAndContinued
    };
  }
}

export class studentInternshipDataModel {
  studentInternshipTitle: string;
  studentInternshipSubTitle: any = [new StudentAv(), new InternshiDetails()];
  studentFeedBack: any = [];
}

export class InternshiDetails {
  subtitle = 'Internship Details';
  showLabels = [
    'Internship keyTitle',
    'Status',
    'Internship Start date',
    'Internship end date',
    'Company Name',
    'Location',
    'Address',
    'Project Name',
    'Accomodation Contact Person',
    'Accomodation Address',
  ];
  keyLabels = [
    'internshipTitle',
    'internshipStatusByMentor',
    'internshipStartDate',
    'internshipEndDate',
    'companyName',
    'locName',
    'locAddress',
    'internshipProjectName',
    'accommodationContactPerson',
    'accommodationAddress',
  ];
  keyDetails: StudentInternShipKeyDetails[] = [];
}

export class StudentAv {
  subtitle = 'Availability Response';
  showLabels = [
    'Available for internship?',
    '4th semester exam start',
    '4th semester exam end',
    'Summer Vacation start',
    'Summer Vacation end',
    'Internship start',
    'Internship end',
    'Remarks (if any)',
  ];
  keyLabels = [
    'isInternshipAssigned',
    'studentExamStartDate',
    'studentExamEndDate',
    'studentSummerVacationStartDate',
    'studentSummerVacationEndDate',
    'studentExpectedInternshipStartDate',
    'studentExpectedInternshipEndDate',
    'studentAvailabilityRemark',
  ];
  keyDetails: StudentInternShipKeyDetails[] = [];
}

export class StudentInternShipKeyDetails {
  showLabel: string;
  showValue: string;
  questionType?: string;
}

export class StudentFeedback {
  subtitle = 'Student Feedback';
  isStudentCompletedInternship = 'Have you completed your Internship?';
  keyDetails: StudentInternShipKeyDetails[] = [];
}

// export class FeedBackQuestions {
//   id: string;
//   question: string;
//   questionType: string;
//   skillType: string;
//   starList: [];
// }
